import { useSlideshowArrows } from '@fukku/slideshow/hooks/useSlideshowArrows/useSlideshowArrows'
import styles from '@fukku/slideshow/Slideshow.module.scss'
import { SlideshowFromDirection } from '@fukku/slideshow/types/Slideshow'
import { IconNextS } from 'icons/components/IconNextS'
import { IconPrevSmall } from 'icons/components/IconPrevSmall'
import { cx } from 'utils/cx'

const REVERSE_ARROW_SIZE = 22

interface SlideshowArrowsProps {
	readonly labels: { previous: string; next: string }
	readonly dataTestId?: string
}

export const SlideshowArrows = ({
	labels,
	dataTestId,
}: SlideshowArrowsProps) => {
	const { handleClick, isArrowNextDisabled, isArrowPreviousDisabled } =
		useSlideshowArrows()

	return (
		<>
			<button
				type='button'
				className={cx(styles.arrow, styles.prevArrow)}
				data-testid={dataTestId && `${dataTestId}.previewItemButton`}
				onClick={(e) => handleClick(e, SlideshowFromDirection.Left)}
				aria-label={labels.previous}
				disabled={isArrowPreviousDisabled}
			>
				<IconPrevSmall color='current-color' className={styles.prevIcon} />
				<IconPrevSmall
					color='current-color'
					className={cx(styles.prevIcon, styles.inversePrevIcon)}
					height={REVERSE_ARROW_SIZE}
					width={REVERSE_ARROW_SIZE}
				/>
			</button>
			<button
				type='button'
				className={cx(styles.arrow, styles.nextArrow)}
				data-testid={dataTestId && `${dataTestId}.nextItemButton`}
				onClick={(e) => handleClick(e, SlideshowFromDirection.Right)}
				aria-label={labels.next}
				disabled={isArrowNextDisabled}
			>
				<IconNextS
					color='current-color'
					className={cx(styles.nextIcon, styles.inverseNextIcon)}
					height={REVERSE_ARROW_SIZE}
					width={REVERSE_ARROW_SIZE}
				/>
				<IconNextS color='current-color' className={styles.nextIcon} />
			</button>
		</>
	)
}
